import { useMemo, useState } from 'react'
import { Compteur } from '../Compteur'
import { LIBELLE_STATUT, badgeStatut, libelleStatut, type Commande, type StatutCommande } from '../../api/types'
import { dateComplete, fcfa } from '../Format'
import { ListeDeroulante } from '../ListeDeroulante'

export function EcranCommandes({ commandes }: { commandes: Commande[] }) {
  const [recherche, setRecherche] = useState('')
  const [statut, setStatut] = useState<StatutCommande | ''>('')

  const visibles = useMemo(() => {
    const q = recherche.trim().toLowerCase()
    return commandes.filter((c) => {
      if (statut && c.statut !== statut) return false
      if (!q) return true
      return [c.ref ?? '', c.clientNom, c.marchandNom, c.clientTelephone].some((v) =>
        v.toLowerCase().includes(q),
      )
    })
  }, [commandes, recherche, statut])

  return (
    <>
      <div className="stats">
        <div className="stat">
          <div className="label">Commandes affichées</div>
<div className="val"><Compteur valeur={String(String(visibles.length))} /></div>
        </div>
        <div className="stat">
          <div className="label">Total encaissé client</div>
{/* « encaissé client » et non « chiffre d'affaires » : SwiftEats est
              AGENT, son CA est la commission + la livraison + les accessoires,
              pas le montant du panier. Les confondre gonflerait le CA d'un
              facteur cinq. */}
          <div className="val"><Compteur valeur={fcfa(visibles.reduce((s, c) => s + c.total, 0))} /></div>
        </div>
      </div>

      <div className="search-bar">
        <input
          placeholder="Rechercher (réf, client, marchand, téléphone…)"
          value={recherche}
          onChange={(e) => setRecherche(e.target.value)}
        />
        <ListeDeroulante
          valeur={statut}
          surChangement={(v) => setStatut(v as StatutCommande | '')}
          options={[
            { valeur: '', libelle: 'Tous statuts' },
            /* La liste vient du TYPE : ajouter une valeur à l'enum Postgres
               sans la déclarer ici ne compile plus. */
            ...(Object.keys(LIBELLE_STATUT) as StatutCommande[]).map((s) => ({
              valeur: s,
              libelle: LIBELLE_STATUT[s],
            })),
          ]}
        />
      </div>

      <div className="card">
        <div className="card-body">
          <table>
            <thead>
              <tr>
                <th>Réf</th><th>Client</th><th>Téléphone</th><th>Marchand</th>
                <th>Livreur</th><th>Statut</th><th>Total</th><th>Date</th>
              </tr>
            </thead>
            <tbody>
              {visibles.length === 0 && (
                <tr>
                  <td colSpan={8} style={{ textAlign: 'center', color: 'var(--n400)', padding: 18 }}>
                    Aucune commande.
                  </td>
                </tr>
              )}
              {visibles.map((c) => (
                <tr key={c.id}>
                  <td>{c.ref ?? c.id.slice(0, 6).toUpperCase()}</td>
                  <td>{c.clientNom}</td>
                  <td>{c.clientTelephone || '—'}</td>
                  <td>{c.marchandNom}</td>
                  <td>{c.livreurNom ?? '—'}</td>
                  <td><span className={`badge ${badgeStatut(c.statut)}`}>{libelleStatut(c.statut)}</span></td>
                  <td>{fcfa(c.total)}</td>
                  <td>{dateComplete(c.creeeLe)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
